"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableBulletChart_1 = require("./PluggableBulletChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var ImplicitDrillDownHelper_1 = require("../../../utils/ImplicitDrillDownHelper");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var BulletChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(BulletChartDescriptor, _super);
    function BulletChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BulletChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableBulletChart_1.PluggableBulletChart(params); };
    };
    BulletChartDescriptor.prototype.applyDrillDown = function (insight, drillDownContext) {
        var withFilters = this.addFiltersForBullet(insight, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    BulletChartDescriptor.prototype.addFiltersForBullet = function (insight, drillConfig, event) {
        var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
        var cutIntersection = sdk_ui_1.getIntersectionPartAfter(event.drillContext.intersection, clicked);
        return drillDownUtil_1.addIntersectionFiltersToInsight(insight, cutIntersection);
    };
    return BulletChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.BulletChartDescriptor = BulletChartDescriptor;
//# sourceMappingURL=BulletChartDescriptor.js.map